import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { getImageUrl } from 'shared/helpers/image.helpers';

import { ICONS_BY_MESSAGE_TYPE, MESSAGE_TYPES } from './constants';
import styles from './styles.module.scss';

interface Props {
  className?: string;
  title?: string;
  message: string | ReactNode;
  messageType?: MESSAGE_TYPES
}

const Message: FC<Props> = ({
  className, title, message, messageType = MESSAGE_TYPES.INFO,
}) => (
  <div className={cn(styles.wrap, className)}>
    <div className={styles.icon}>
      <img src={getImageUrl(ICONS_BY_MESSAGE_TYPE[messageType])} alt={messageType} />
    </div>
    <div className={styles.main}>
      <div className={styles.title}>{title}</div>
      <div className={styles.message}>{message}</div>
    </div>
  </div>
);

Message.defaultProps = {
  className: '',
  title: 'Transaction changes',
  messageType: MESSAGE_TYPES.INFO,
};

export default Message;
